// @ts-nocheck
import { commentsBaseUrl } from '../apiUrls';
import type { Dispatch } from 'redux';
import axios from '../../../../services/api';
import { CommentsAction, CommentsActions } from '../types/comments';
import { CrmRelationType } from '../models/CrmRelationType';
import { ICommentInsertModel } from '../models/CommentInsertModel';
import { normalizeMediaBeforeSave } from '../../../detail-form/richTextMediaHelpers';

export const getComments = (entityId: string, entityTypeId: CrmRelationType) => {
  return async (dispatch: Dispatch<CommentsAction>) => {
    try {
      dispatch({ type: CommentsActions.GET_COMMENTS });
      const response = await axios.get(commentsBaseUrl + 'GetComments/', {
        params: { entityId, entityTypeId },
      });
      dispatch({
        type: CommentsActions.GET_COMMENTS_SUCCESS,
        payload: response.data,
      });
    } catch (e) {
      dispatch({
        type: CommentsActions.GET_COMMENTS_ERROR,
        payload: `ERROR: Can't get comments`,
      });
    }
  };
};

export const addComment = (entity: ICommentInsertModel) => {
  return async (dispatch: Dispatch<CommentsAction>) => {
    try {
      dispatch({ type: CommentsActions.ADD_COMMENT });
      const response = await axios.post(commentsBaseUrl + 'AddComment/', {
        ...entity,
        CommentContent: normalizeMediaBeforeSave(entity.CommentContent || ''),
      });
      dispatch({
        type: CommentsActions.ADD_COMMENT_SUCCESS,
        payload: response.data,
      });
    } catch (e) {
      dispatch({
        type: CommentsActions.ADD_COMMENT_ERROR,
        payload: `ERROR: Can't add comment`,
      });
    }
  };
};

export const editComment = (commentInsertModel: ICommentInsertModel) => {
  return async (dispatch: Dispatch<CommentsAction>) => {
    try {
      dispatch({ type: CommentsActions.EDIT_COMMENT });
      const response = await axios.put(commentsBaseUrl + 'EditComment/', {
        ...commentInsertModel,
        CommentContent: normalizeMediaBeforeSave(commentInsertModel.CommentContent || ''),
      });
      dispatch({
        type: CommentsActions.EDIT_COMMENT_SUCCESS,
        payload: response.data,
      });
    } catch (e) {
      dispatch({
        type: CommentsActions.EDIT_COMMENT_ERROR,
        payload: `ERROR: Can't edit comment`,
      });
    }
  };
};

export const deleteComment = (commentId: number) => {
  return async (dispatch: Dispatch<CommentsAction>) => {
    try {
      dispatch({ type: CommentsActions.DELETE_COMMENTS });
      const response = await axios.delete(commentsBaseUrl + 'DeleteComment/', {
        params: { commentId: commentId },
      });
      dispatch({
        type: CommentsActions.DELETE_COMMENTS_SUCCESS,
        payload: response.data.Data,
      });
    } catch (e) {
      dispatch({
        type: CommentsActions.DELETE_COMMENTS_ERROR,
        payload: `ERROR: Can't delete comment`,
      });
    }
  };
};
